export default "__VITE_ASSET__DtZ1QwRr__"